<div class="table-component" [ngClass]="{ fullscreen: isFullScreenMode }">
    <ng-container>
        <ng-container *ngIf="showTableHeader">
            <fui-table-header
                #tableHeader
                [isLoading]="(isLoaded$ | async) === false"
                [forceButtonPanel]="forceButtonPanel$ | async"
                [ngClass]="{ headerHidden: isFullScreenMode }"
            >
                <ng-content fui-table-header-title select="[fui-table-header-title]"></ng-content>
                <ng-content table-header-right-block select="[table-header-right-block]"></ng-content>
                <ng-container buttons-panel-extra select="[buttons-panel-extra]">
                    <!-- Расширенный поиск -->
                    <ng-container *ngIf="formFilter.isFilter$ | async">
                        <fui-button
                            (clickEvent)="toggleFilter()"
                            [title]="appService.language_dictionary.system_header_advanced_search"
                            icon="magnify"
                            type="button-icon"
                            [color]="(this.formFilter.isOpenFilter$ | async) ? 'soft' : 'gray'"
                            height="slim"
                            borderRadius="circle"
                        ></fui-button>
                    </ng-container>
                    <!-- Сохраненные поиски -->
                    <ng-container *ngIf="(formFilterSavedSearchesService.filterRecordsLength$ | async) > 0">
                        <fui-button
                            type="button-icon"
                            color="gray"
                            height="slim"
                            borderRadius="circle"
                            icon="list-box-outline"
                            [title]="appService.language_dictionary.factor_saved_searches"
                            [matMenuTriggerFor]="menuFilter"
                        ></fui-button>
                        <mat-menu #menuFilter="matMenu">
                            <div class="extend-filter-save-list">
                                <ng-container
                                    *ngFor="let filter of formFilterSavedSearchesService.filterRecords$ | async"
                                >
                                    <button
                                        (click)="formFilterSavedSearchesService.select(filter)"
                                        [class.active]="
                                            (formFilterSavedSearchesService.selectedFilterId$ | async) === filter.id
                                        "
                                        type="button"
                                        mat-menu-item
                                        class="context-menu-item"
                                    >
                                        <div class="flex flex-row">
                                            <span>{{ filter.name[appService.currentLanguage] }}</span>
                                        </div>
                                        <fui-button
                                            (clickEvent)="
                                                formFilterSavedSearchesService.deleteFilterRecord($event, filter)
                                            "
                                            [title]="appService.language_dictionary.delete_search_preferences"
                                            [disabled]="
                                                (formFilterSavedSearchesService.selectedFilterId$ | async) === filter.id
                                            "
                                            class="mt-[2px] ml-1"
                                            icon="delete-outline"
                                            color="flat"
                                            height="slim"
                                            type="button-icon"
                                        >
                                        </fui-button>
                                    </button>
                                </ng-container>
                            </div>
                        </mat-menu>
                    </ng-container>
                </ng-container>
            </fui-table-header>
        </ng-container>
        <div *ngIf="formFilter.isFilter$ | async">
            <app-form-filter
                [formDynamic]="form"
                [settingData]="selectFilter"
                [tableService]="tableService"
                (setFilter)="setExtendFilter()"
            >
            </app-form-filter>
        </div>
        <ng-container *ngIf="isLoaded$ | async; else elseNonLoad">
            <div
                #tableContainer
                *ngIf="showTableContent$ | async"
                class="content content-sticky table-container-element h-full flex flex-col {{ classTable }}"
            >
                <div class="h-full flex flex-col gap-y-[12px]">
                    <div class="h-full" *ngIf="requestError">
                        <div class="table-panel">
                            <div class="buttons">
                                <ng-container [ngTemplateOutlet]="tableSettingsButton"></ng-container>
                            </div>
                        </div>
                        <div class="empty-table-content">
                            {{ appService.language_dictionary.table_settings_request_error }}
                        </div>
                    </div>
                    <ng-container *ngIf="(emptyResult$ | async) && !requestError && isEmptyFilter()">
                        <div class="text-secondary empty-table-content">
                            {{ appService.language_dictionary.system_user_table_no_results }}
                        </div>
                    </ng-container>
                    <mat-card
                        #tableCard
                        class="h-full box-border table-card"
                        *ngIf="!requestError && !((emptyResult$ | async) && isEmptyFilter())"
                        [class.full-height]="isFullHeight$ | async"
                    >
                        <mat-card-content>
                            <div class="table-panel" #tablePanel>
                                <div class="buttons">
                                    <fui-button
                                        (clickEvent)="toggleTableFilter()"
                                        [title]="
                                            isColumnFilter
                                                ? appService.language_dictionary.table_hide_filter
                                                : appService.language_dictionary.table_show_filter
                                        "
                                        [color]="isColumnFilter ? 'soft' : 'flat'"
                                        borderRadius="circle"
                                        type="button-icon"
                                        height="slim"
                                        icon="filter-outline"
                                    >
                                    </fui-button>
                                    <ng-container [ngTemplateOutlet]="tableSettingsButton"></ng-container>
                                    <ng-container *ngIf="isChangeTracking">
                                        <ng-template [ngTemplateOutlet]="changeForm"></ng-template>
                                    </ng-container>
                                </div>
                                <div class="paginator">
                                    <custom-paginator
                                        table-header
                                        #UsersMatPaginatorTop
                                        (page)="pageEvent = onPaginateChange($event)"
                                        [length]="lengthTables"
                                        [pageIndex]="settingsTable.userIndex"
                                        [pageSize]="settingsTable.userSize"
                                        [pageSizeOptions]="pageSizeOptionsTables"
                                    >
                                    </custom-paginator>
                                </div>
                            </div>

                            <div [class.full-height-scroll-wrapper]="isFullHeight$ | async" class="mat-table-wrapper" #matTable>
                                <div
                                    class="mat-table-container mat-table-container-table"
                                    [class.full-height-scroll]="isFullHeight$ | async"
                                    [class.empty-filter]="!isColumnFilter"
                                    [class.!hidden]="!loadSettings"
                                >
                                    <mat-table
                                        #dataMatTable="matTable"
                                        #UsersMatSort="customSort"
                                        (customSortChange)="sortData($event)"
                                        [dataSource]="dataTables.filteredData"
                                        customSort
                                        [customSortDisableClear]="true"
                                        [customSortActive]="settingsTable.userSort"
                                    >
                                        <ng-container matColumnDef="select" sticky>
                                            <mat-header-cell *matHeaderCellDef class="header-cell-select">
                                                <div>
                                                    <div [class.hidden]="selection.hasValue()" class="number">№</div>
                                                    <div [class.hidden]="!selection.hasValue()" class="master-toggle">
                                                        <mat-checkbox
                                                            (change)="$event ? masterToggle() : null"
                                                            [fuiTooltip]="
                                                                appService.language_dictionary.check_all_table_row
                                                            "
                                                            [checked]="selection.hasValue() && isAllSelected()"
                                                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                                                            [aria-label]="checkboxLabel()"
                                                        >
                                                        </mat-checkbox>
                                                    </div>
                                                </div>
                                                <ng-container *ngIf="isColumnFilter; else hiddenColumnFilter">
                                                    <ng-template [ngTemplateOutlet]="emptyColumnFilter"></ng-template>
                                                </ng-container>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let row; let index = index" class="cell-select">
                                                <mat-checkbox
                                                    (click)="$event.stopPropagation()"
                                                    (dblclick)="$event.stopPropagation()"
                                                    (change)="$event ? selection.toggle(row) : null"
                                                    [checked]="selection.isSelected(row)"
                                                    [aria-label]="checkboxLabel(row)"
                                                >
                                                </mat-checkbox>
                                                <div class="number">{{ index + 1 + getTablePagination() }}</div>
                                            </mat-cell>
                                        </ng-container>
                                        <!-- Палитры в таблице -->
                                        <ng-container *ngIf="dataPalette && dataPalette.length">
                                            <ng-container *ngFor="let columnPalette of dataPalette">
                                                <!-- Если простая палитра -->
                                                <ng-container *ngIf="!columnPalette.merged">
                                                    <ng-container
                                                        [matColumnDef]="'system_color_' + columnPalette.index"
                                                    >
                                                        <mat-header-cell *matHeaderCellDef class="header-cell-palette">
                                                            <div>
                                                                <mat-icon
                                                                    class="table-color-history"
                                                                    [fuiTooltip]="columnPalette.title"
                                                                    #menuColorHistoryTrigger="matMenuTrigger"
                                                                    [matMenuTriggerFor]="menuColorHistory"
                                                                    >{{ columnPalette.icon }}
                                                                </mat-icon>
                                                                <mat-menu #menuColorHistory="matMenu">
                                                                    <div
                                                                        class="relative"
                                                                        (click)="$event.stopPropagation()"
                                                                    >
                                                                        <app-palette-legend
                                                                            [palette]="columnPalette"
                                                                        ></app-palette-legend>
                                                                        <div class="absolute -top-1 right-1">
                                                                            <fui-button
                                                                                type="button-icon"
                                                                                height="slim"
                                                                                borderRadius="circle"
                                                                                color="color"
                                                                                icon="close"
                                                                                (clickEvent)="
                                                                                    menuColorHistoryTrigger.closeMenu()
                                                                                "
                                                                                title="{{
                                                                                    appService.language_dictionary
                                                                                        .system_close
                                                                                }}"
                                                                            ></fui-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-menu>
                                                            </div>
                                                            <ng-container
                                                                *ngIf="isColumnFilter; else hiddenColumnFilter"
                                                            >
                                                                <ng-template
                                                                    [ngTemplateOutlet]="emptyColumnFilter"
                                                                ></ng-template>
                                                            </ng-container>
                                                        </mat-header-cell>
                                                        <mat-cell
                                                            *matCellDef="let row"
                                                            style="width: 44px"
                                                            class="text-center"
                                                        >
                                                            <ng-container *ngIf="row['color_' + columnPalette.index]">
                                                                <span
                                                                    class="table-color-element"
                                                                    [style.backgroundColor]="
                                                                        row['color_' + columnPalette.index]
                                                                    "
                                                                ></span>
                                                            </ng-container>
                                                        </mat-cell>
                                                    </ng-container>
                                                </ng-container>
                                                <!-- Если сложная палитра -->
                                                <ng-container *ngIf="columnPalette.merged">
                                                    <ng-container
                                                        [matColumnDef]="'system_color_' + columnPalette.index"
                                                    >
                                                        <mat-header-cell *matHeaderCellDef class="header-cell-palette">
                                                            <div>
                                                                <mat-icon
                                                                    class="table-color-history"
                                                                    [fuiTooltip]="
                                                                        appService.language_dictionary.palette_legend
                                                                    "
                                                                    #menuColorHistoryTrigger="matMenuTrigger"
                                                                    [matMenuTriggerFor]="menuColorHistory"
                                                                    >{{ columnPalette.icon }}
                                                                </mat-icon>
                                                                <mat-menu #menuColorHistory="matMenu">
                                                                    <div
                                                                        class="relative"
                                                                        (click)="$event.stopPropagation()"
                                                                    >
                                                                        <app-palette-legend
                                                                            [palette]="columnPalette"
                                                                        ></app-palette-legend>
                                                                        <div class="absolute -top-1 right-1">
                                                                            <fui-button
                                                                                type="button-icon"
                                                                                height="slim"
                                                                                borderRadius="circle"
                                                                                color="color"
                                                                                icon="close"
                                                                                (clickEvent)="
                                                                                    menuColorHistoryTrigger.closeMenu()
                                                                                "
                                                                                title="{{
                                                                                    appService.language_dictionary
                                                                                        .system_close
                                                                                }}"
                                                                            ></fui-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-menu>
                                                            </div>
                                                            <ng-container
                                                                *ngIf="isColumnFilter; else hiddenColumnFilter"
                                                            >
                                                                <ng-template
                                                                    [ngTemplateOutlet]="emptyColumnFilter"
                                                                ></ng-template>
                                                            </ng-container>
                                                        </mat-header-cell>
                                                        <ng-container
                                                            *ngFor="let mergedPalette of columnPalette.merged_data"
                                                        >
                                                            <ng-container *ngIf="!mergedPalette.main">
                                                                <mat-cell
                                                                    *matCellDef="let row"
                                                                    style="width: 44px"
                                                                    class="text-center"
                                                                >
                                                                    <ng-container
                                                                        *ngIf="row['color_' + mergedPalette.index]"
                                                                    >
                                                                        <span
                                                                            class="table-color-element"
                                                                            [style.backgroundColor]="
                                                                                row['color_' + mergedPalette.index]
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                </mat-cell>
                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                        <!-- Пользовательские колонки в таблице  -->
                                        <ng-container
                                            *ngFor="
                                                let column of settingsTable.userColumns;
                                                let i = index;
                                                trackBy: trackByUserColumnsName
                                            "
                                            [matColumnDef]="column.name"
                                            [sticky]="column.is_sticky"
                                        >
                                            <mat-header-cell
                                                class="mat-table-column-class"
                                                *matHeaderCellDef
                                                mwlResizable
                                                resizeColumn
                                                [enableGhostResize]="true"
                                                [targetColumn]="column"
                                                [resizeEdges]="{
                                                    bottom: false,
                                                    right: true,
                                                    top: false,
                                                    left: i !== 0,
                                                }"
                                                [style.width.px]="column.width"
                                            >
                                                <div
                                                    [custom-sort-header]="column.name"
                                                    [class]="getAlign(column) === 'right' ? 'header-align-right' : ''"
                                                    [fuiTooltip]="stripHtml(column.title)"
                                                >
                                                    <div [innerHTML]="column.title | escapeHtml"></div>
                                                </div>
                                                <!--  Фильтры для колонок -->
                                                <ng-container *ngIf="isColumnFilter; else hiddenColumnFilter">
                                                    <div class="column-filter">
                                                        <ng-container [ngSwitch]="column.type">
                                                            <ng-container *ngSwitchCase="'boolean'">
                                                                <ng-container
                                                                    [ngTemplateOutlet]="booleanFilter"
                                                                    [ngTemplateOutletContext]="{ column }"
                                                                >
                                                                </ng-container>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'bool'">
                                                                <ng-container
                                                                    [ngTemplateOutlet]="booleanFilter"
                                                                    [ngTemplateOutletContext]="{ column }"
                                                                >
                                                                </ng-container>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'checkbox'">
                                                                <ng-container
                                                                    [ngTemplateOutlet]="booleanFilter"
                                                                    [ngTemplateOutletContext]="{ column }"
                                                                >
                                                                </ng-container>
                                                            </ng-container>
                                                            <ng-container *ngSwitchDefault>
                                                                <mat-form-field appearance="outline">
                                                                    <input
                                                                        matInput
                                                                        [(ngModel)]="filterTable[column.name]"
                                                                        (ngModelChange)="inputValueChanged($event)"
                                                                    />
                                                                    <button
                                                                        mat-button
                                                                        *ngIf="filterTable[column.name]"
                                                                        matSuffix
                                                                        mat-icon-button
                                                                        title="{{
                                                                            appService.language_dictionary.system_clear
                                                                        }}"
                                                                        (click)="
                                                                            filterTable[column.name] = '';
                                                                            changeFilter()
                                                                        "
                                                                    >
                                                                        <mat-icon>close</mat-icon>
                                                                    </button>
                                                                </mat-form-field>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </mat-header-cell>
                                            <mat-cell
                                                class="mat-table-column-class"
                                                *matCellDef="let row"
                                                fuiTooltip="{{
                                                    column.hasOwnProperty('cell')
                                                        ? (column.cell(row)
                                                          | formater: column.type : '' : column?.transformParam)
                                                        : ''
                                                }}"
                                                (click)="
                                                    groupByTreeColumns?.isTree &&
                                                    groupByTreeColumns?.columnGroup === column.name
                                                        ? groupHeaderTreeClick(row)
                                                        : null
                                                "
                                                [class.color-row]="!!row[mainPalette]"
                                                [style.background-color]="row[mainPalette]"
                                                [style.width.px]="column.width"
                                                [style.border-bottom-color]="
                                                    !!row[mainPalette] ? '#ffffff' : 'rgba(0, 0, 0, .12)'
                                                "
                                                [style.text-align]="getAlign(column)"
                                            >
                                                <div
                                                    class="cell-content"
                                                    [style.-webkit-line-clamp]="settingsTable.cell_rows"
                                                    [style]="column.type === 'float' ? 'padding-right: 0.5em' : null"
                                                >
                                                    <ng-container
                                                        *ngIf="
                                                            settingsEditFields?.isEdit &&
                                                            (!settingsEditFields.excludeField ||
                                                                (settingsEditFields.excludeField &&
                                                                    !row[settingsEditFields.excludeField])) &&
                                                            settingsEditFields?.fields[column.name] &&
                                                            formEdit.get(column.name + '_' + row.id)
                                                        "
                                                    >
                                                        <ng-container
                                                            dynamic-field
                                                            [field]="{
                                                                type: settingsEditFields?.fields[column.name].type,
                                                                label: '',
                                                                mask: settingsEditFields?.fields[column.name].mask
                                                                    ? settingsEditFields?.fields[column.name].mask
                                                                    : null,
                                                                name: 'value',
                                                                validations: [],
                                                            }"
                                                            [group]="formEdit.get(column.name + '_' + row.id)"
                                                        >
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="
                                                            !settingsEditFields?.isEdit ||
                                                            (settingsEditFields?.isEdit &&
                                                                (!settingsEditFields?.fields[column.name] ||
                                                                    (settingsEditFields.excludeField &&
                                                                        row[settingsEditFields.excludeField])))
                                                        "
                                                    >
                                                        <ng-container
                                                            *ngIf="
                                                                groupByTreeColumns?.isTree &&
                                                                groupByTreeColumns?.columnGroup === column.name
                                                            "
                                                        >
                                                            <ng-container *ngIf="row.level > 1">
                                                                <ng-container
                                                                    *ngFor="let i of [].constructor(row.level - 1)"
                                                                >
                                                                    <span class="table-tree-indentation">&nbsp;</span>
                                                                </ng-container>
                                                            </ng-container>
                                                            <button *ngIf="row?.is_children" mat-icon-button>
                                                                <mat-icon class="mat-icon-rtl-mirror">
                                                                    {{ row?.expanded ? 'expand_less' : 'expand_more' }}
                                                                </mat-icon>
                                                            </button>
                                                            <span
                                                                *ngIf="!row?.is_children"
                                                                class="table-tree-indentation"
                                                                >&nbsp;</span
                                                            >
                                                        </ng-container>
                                                        <ng-container *ngIf="column.is_group; else single">
                                                            <span [innerHtml]="column.cell(row)"></span>
                                                        </ng-container>
                                                        <ng-template #single>
                                                            <ng-container *ngIf="column?.cell">
                                                                <!--  Вставляем контент в ячейку в зависимости от типа-->
                                                                <ng-container [ngSwitch]="column.type">
                                                                    <ng-container *ngSwitchCase="'HtmlTextType'">
                                                                        <span [innerHtml]="column.cell(row)"></span>
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'link'">
                                                                        <span
                                                                            [innerHtml]="
                                                                                column.cell(row) | sanitizeHtml
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'reestr'">
                                                                        <span
                                                                            [innerHtml]="
                                                                                column.cell(row) | sanitizeHtml
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'gallery'">
                                                                        <span
                                                                            [innerHtml]="
                                                                                column.cell(row) | sanitizeHtml
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'file'">
                                                                        <span
                                                                            [innerHtml]="
                                                                                column.cell(row) | sanitizeHtml
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'color'">
                                                                        <span
                                                                            [innerHtml]="
                                                                                column.cell(row) | sanitizeHtml
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'list'">
                                                                        <app-table-cell-list
                                                                            [column]="column"
                                                                            [row]="row"
                                                                        ></app-table-cell-list>
                                                                    </ng-container>

                                                                    <ng-container *ngSwitchCase="'float'">
                                                                        {{
                                                                            column.cell(row)
                                                                                | formater
                                                                                    : column.type
                                                                                    : ''
                                                                                    : column?.transformParam
                                                                        }}
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchDefault>
                                                                        {{ column.cell(row) | formater: column.type }}
                                                                    </ng-container>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-template>
                                                    </ng-container>
                                                </div>
                                            </mat-cell>
                                        </ng-container>
                                        <mat-header-row *matHeaderRowDef="settingsTable.displayedColumns; sticky: true">
                                        </mat-header-row>
                                        <mat-row
                                            [id]="'row-' + index"
                                            [class.mat-row-selected]="selection.isSelected(row)"
                                            *matRowDef="
                                                let row;
                                                columns: settingsTable.displayedColumns;
                                                let index = index
                                            "
                                            (click)="
                                                settingsEditFields?.isEdit
                                                    ? null
                                                    : $event
                                                      ? selection.toggle(row)
                                                      : null
                                            "
                                            (dblclick)="
                                                $event.stopPropagation(); callParent('dblClickRow', row, $event)
                                            "
                                            (contextmenu)="onRightClick($event, row)"
                                        ></mat-row>
                                    </mat-table>
                                    <mat-card *ngIf="(emptyResult$ | async) && !requestError">
                                        {{ appService.language_dictionary.system_user_table_no_results_found }}
                                    </mat-card>
                                </div>
                                <div class="table-block-load" [class.!hidden]="loadSettings"></div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <ngx-spinner [name]="spinnerName" [fullScreen]="false" bdColor="transparent" [template]="spinnerHtml">
            </ngx-spinner>
        </ng-container>
        <ng-template #elseNonLoad>
            <div class="skeleton-container px-2">
                <div class="w-full mb-2">
                    <div class="skeleton w-full h-8"></div>
                </div>
                <div class="w-full flex justify-between gap-2">
                    <div *ngFor="let _ of [].constructor(6)" class="w-full h-6 skeleton"></div>
                </div>
            </div>
        </ng-template>
    </ng-container>
</div>
<ng-template #changeForm let-field="field">
    <fui-button
        (clickEvent)="
            factorRowHistoryService.showRevisionHistory(
                { id: factorRowService.factorId, data_type: 'relation' },
                form,
                null,
                {
                    spinner: spinner,
                    notifier: notifier,
                    dialog: dialog,
                    service: factorRowService,
                    factorDataId: factorRowService.factorDataId,
                    currentLangForm: currentLangRelationForm,
                    tableData: item,
                }
            )
        "
        [icon]="'clock-outline'"
        [title]="appService.language_dictionary.factor_show_revision_history"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'gray'"
        [height]="'slim'"
    >
    </fui-button>
</ng-template>
<ng-template #booleanFilter let-column="column">
    <mat-form-field class="form-full-width" appearance="outline">
        <mat-select
            #matSelect
            [(ngModel)]="filterTable[column.name]"
            [panelClass]="setPanelClass(matSelect)"
            (selectionChange)="changeFilter()"
        >
            <mat-option [value]="''">
                {{ appService.language_dictionary.system_all }}
            </mat-option>
            <mat-option [value]="1">
                {{ appService.language_dictionary.system_yes }}
            </mat-option>
            <mat-option [value]="0">
                {{ appService.language_dictionary.system_no }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>
<!-- Заглушка если нет фильтра у колонки, а ячейку показать нужно -->
<ng-template #emptyColumnFilter>
    <div class="column-filter">&nbsp;</div>
</ng-template>
<!-- Фильтр спрятян, ячейку показывать не нужно -->
<ng-template #hiddenColumnFilter></ng-template>
<!-- Кнопка настроек таблицы -->
<ng-template #tableSettingsButton>
    <ng-container *ngIf="!tableService?.hideTableSettings">
        <fui-button
            (clickEvent)="openSettingsDialog()"
            title="{{ appService.language_dictionary.system_user_table_settings }}"
            borderRadius="circle"
            type="button-icon"
            height="slim"
            icon="tune"
            color="flat"
        >
        </fui-button>
    </ng-container>
</ng-template>
